import React__default from 'react';
import { defaultLocaleCtx } from './constants.js';

var I18nContext = /*#__PURE__*/React__default.createContext(defaultLocaleCtx);

export { I18nContext };
